import { Reveal, SectionHeader } from "./Bits";

const CARDS = [
  {
    tag: "CLASSIFIED",
    title: "ADAPTIVE SENTRY AI",
    body: "Hostiles coordinate, flank and remember. Patrol routes re-seed every infiltration — no two runs share a pattern.",
    redacted: "last confirmed breach [REDACTED]",
    meta: "REF: EX-0117 // CLEARANCE: L4",
  },
  {
    tag: "FIELD REPORT",
    title: "SOUND PROPAGATION",
    body: "Every footstep is a signal. Surfaces, weather and line-of-sight decide who hears you first — and who never hears anything again.",
    redacted: "acoustic model v9 sealed",
    meta: "REF: EX-0231 // CLEARANCE: L3",
  },
  {
    tag: "EYES ONLY",
    title: "GHOST PROTOCOL",
    body: "No kills. No alarms. No trace. The mission grades your absence, not your presence.",
    redacted: "zero-trace bonus active",
    meta: "REF: EX-0000 // CLEARANCE: L5",
  },
  {
    tag: "SIGINT",
    title: "DYNAMIC NIGHT CYCLE",
    body: "Power grids, searchlights and storm fronts are systems to be cut, not set dressing. Darkness is a resource you manufacture.",
    redacted: "grid sabotage sanctioned",
    meta: "REF: EX-0404 // CLEARANCE: L4",
  },
];

export const Intel = () => (
  <section id="intel" data-testid="intel-section" className="px-6 py-28 md:px-12 md:py-36">
    <div className="mx-auto max-w-[1400px]">
      <SectionHeader
        index="01"
        label="INTEL"
        title="Field Intelligence"
        desc="Recovered from a dead drop outside Severodvinsk. Contents verified. Sources did not survive verification."
      />
      <div className="grid gap-px border border-line bg-line md:grid-cols-2">
        {CARDS.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.08}>
            <article
              data-testid={`dossier-card-${i}`}
              className="glitch-hover group h-full bg-[#0A0E12] p-8 transition-colors duration-150 hover:bg-[#121820] md:p-10"
            >
              <div className="flex items-center gap-3 font-mono text-[10px] font-bold tracking-[0.3em]">
                <span className="h-1.5 w-1.5 bg-signal" />
                <span className="text-signal">{card.tag}</span>
                <span className="h-px flex-1 bg-line" />
                <span className="text-slate-600">0{i + 1}</span>
              </div>
              <h3 className="mt-6 font-mono text-xl font-bold uppercase tracking-wide text-[#F8FAFC] transition-colors group-hover:text-signal md:text-2xl">
                {card.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-slate-400">{card.body}</p>
              <p className="mt-4 font-mono text-xs text-slate-500">
                <span className="redacted">{card.redacted}</span>
              </p>
              <p className="mt-8 border-t border-line pt-4 font-mono text-[10px] tracking-[0.25em] text-slate-600">
                {card.meta}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
